import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this a physical product or a digital download?',
  a: 'This is a 100% digital product delivered in high-quality PDF format and editable files. You can access it from your computer, tablet, or smartphone immediately after purchase.'
}, {
  q: 'Is it suitable for newly qualified therapists?',
  a: 'Yes. The system is the ideal foundation for both new professionals who need structure and experienced therapists who want to optimize their time and standardize their quality.'
}, {
  q: 'Can I use it in private practice and clinics?',
  a: 'Absolutely. The assessment tools, worksheets, and documentation systems are perfectly adaptable to private practice, mental health clinics, and counseling services.'
}, {
  q: 'Does it cover different clinical concerns?',
  a: 'Yes. The system includes materials for the most common challenges: anxiety, depression, trauma, low self-esteem, stress management, and relational difficulties.'
}, {
  q: 'How quickly will I notice the benefits?',
  a: 'Most therapists report feeling significantly more organized and confident before entering a session from the very first day they implement the kit.'
}, {
  q: 'Do I need special software to use these resources?',
  a: 'No. Everything is provided in standard, universally accessible formats (PDFs and editable documents) that open on any device—no expensive or specialized software required.'
}, {
  q: 'Are the worksheets and handouts customizable?',
  a: 'Yes. The Clinical Worksheets Library and the 30 Ready-to-Print Client Handouts include editable templates, so you can tailor wording, exercises, and homework to each individual client.'
}, {
  q: 'Is this a monthly subscription?',
  a: 'No. It is a one-time payment of $27 USD. You get lifetime access to the complete 6-in-1 system and all 5 premium bonuses with no recurring fees.'
}, {
  q: 'Can I share these resources with clients and colleagues?',
  a: 'Yes. Your purchase lets you use these resources within your own practice, deliver handouts and homework to your clients, and standardize workflows with your direct clinical team.'
}, {
  q: 'What if I am not satisfied with the system?',
  a: 'You are protected by our 7-Day Money-Back Guarantee. If you are not completely satisfied, simply email us within 7 days of purchase for a full, no-questions-asked refund.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-14 px-4 sm:px-6 bg-white" data-id="element-39">
      <div className="text-center mb-12" data-id="element-40">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-3 uppercase leading-tight" data-id="element-41">
          FREQUENTLY ASKED QUESTIONS
        </h2>
      </div>

      <div className="flex flex-col gap-4 max-w-3xl mx-auto" data-id="element-42">
        {faqs.map((faq, i) => <div key={i} className="bg-brand-paper border border-gray-200 rounded-xl overflow-hidden shadow-sm transition-colors hover:border-brand-navy/30" data-id="element-43">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center gap-4 focus:outline-none" aria-expanded={openIndex === i} data-id="element-44">
              <span className="font-bold text-brand-navy text-sm sm:text-base leading-tight" data-id="element-45">
                {faq.q}
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-brand-navy transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-46" />
            </button>

            {openIndex === i && <div className="px-6 pb-6 text-brand-ink/80 text-sm leading-relaxed border-t border-gray-200 pt-5" data-id="element-47">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}